import { createFileRoute } from '@tanstack/react-router';

import { TennisForm } from '../-components/TennisForm';

export const Route = createFileRoute('/_authenticated/teams/tennisPlayers/new')({
    component: TennisForm,
});
